// TO_DEPRECATE: Every module calls their own $router.addRoute(); this function includes all those calls separately in the bundle.
// Refactor so that only routes are added which are available for this instance (1 instance per tenant).

function importAll(context) {
  context.keys().forEach(context);
}

importAll(require.context('../modules/', true, /\/routes\/.*\.js/));
